import { isSingleLineListView } from 'owa-mail-layout';

export default function getDefaultPreviewLinesToShow(): number {
    return isSingleLineListView() ? 0 : 1;
}
